export const MAX_SCORE_KEY = 'arcade-shooter:max-score';
export const RECORDS_KEY = 'arcade-shooter:records:v1';

export function getMaxScoreKey(namespace = 'shooter') {
  return namespace === 'shooter'
    ? MAX_SCORE_KEY
    : `arcade-${namespace}:max-score`;
}

export function getRecordsKey(namespace = 'shooter') {
  return namespace === 'shooter'
    ? RECORDS_KEY
    : `arcade-${namespace}:records:v1`;
}

export function readMaxScore(storage = window.localStorage, namespace = 'shooter') {
  const stored = storage.getItem(getMaxScoreKey(namespace));
  const parsed = Number(stored);

  return Number.isFinite(parsed) ? parsed : 0;
}

export function writeMaxScore(score, storage = window.localStorage, namespace = 'shooter') {
  storage.setItem(getMaxScoreKey(namespace), String(score));
}

export function createEmptyRecords() {
  return {
    normal: {
      completedSectors: [],
      bestScore: 0,
      badges: {},
    },
    practice: {
      bestBySector: {},
      completedSectors: [],
      badges: {},
    },
  };
}

export function readRecords(storage = window.localStorage, namespace = 'shooter') {
  const emptyRecords = createEmptyRecords();
  const stored = storage.getItem(getRecordsKey(namespace));

  if (!stored) {
    return emptyRecords;
  }

  try {
    const parsed = JSON.parse(stored);

    return {
      normal: {
        ...emptyRecords.normal,
        ...(parsed.normal ?? {}),
      },
      practice: {
        ...emptyRecords.practice,
        ...(parsed.practice ?? {}),
      },
    };
  } catch (error) {
    return emptyRecords;
  }
}

export function writeRecords(records, storage = window.localStorage, namespace = 'shooter') {
  storage.setItem(getRecordsKey(namespace), JSON.stringify(records));
}
